// removed by extract-text-webpack-plugin
module.exports = {"slide":"slide__slide___3G1mg"};


//////////////////
// WEBPACK FOOTER
// ./app/components/Object/Slider/Slide/slide.scss
// module id = 932
// module chunks = 0